import PropTypes from 'prop-types';
import React from 'react';
import {
  Form,
  InputNumber,
} from 'antd';
import PlanRow from './PlanRow';


const Plan = ({ coexecutorData, formRef }) => {
  const steps = () => {
    if (coexecutorData.isNIR) {
      return [
        {
          step: 1,
          active: coexecutorData.coexecutorsPersonId.isStep1,
        },
        {
          step: 2,
          active: coexecutorData.coexecutorsPersonId.isStep2,
        },
        {
          step: 3,
          active: coexecutorData.coexecutorsPersonId.isStep3,
        },
        {
          step: 4,
          active: coexecutorData.coexecutorsPersonId.isStep4,
        },
        {
          step: 5,
          active: coexecutorData.coexecutorsPersonId.isStep5,
        },
        {
          step: 6,
          active: coexecutorData.coexecutorsPersonId.isStep6,
        },
      ];
    }

    if (coexecutorData.isS) {
      return [
        {
          step: 1,
          active: coexecutorData.coexecutorsPersonId.isStep1 || coexecutorData.coexecutorsPersonId.isStep2,
        },
        {
          step: 2,
          active: coexecutorData.coexecutorsPersonId.isStep3 || coexecutorData.coexecutorsPersonId.isStep4,
        },
        {
          step: 3,
          active: coexecutorData.coexecutorsPersonId.isStep5 || coexecutorData.coexecutorsPersonId.isStep6,
        },
      ];
    }

    return [];
  };

  return (
    <>
      <div className="common-subTitle" style={{ marginTop: '40px' }}>
        <b>План-график исполнения обязательств</b>
      </div>
      <div className="common-table-wrapper" style={{ marginTop: '10px' }}>
        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{
              width: '4%',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            № п/п
          </div>
          <div
            className="common-table-row-cell"
            style={{
              width: '24%',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Номер этапа выполнения работ
          </div>
          <div
            className="common-table-row-cell"
            style={{
              width: '24%',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Содержание выполняемых работ и мероприятий
          </div>
          <div
            className="common-table-row-cell"
            style={{
              width: '24%',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Перечень разрабатываемых документов
          </div>
          <div
            className="common-table-row-cell"
            style={{
              width: '24%',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Дата начала и окончания выполнения работ в рамках этапа
          </div>
          {coexecutorData.isNIR && (
          <div
            className="common-table-row-cell"
            style={{
              width: '24%',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px solid #d9d9d9',
            }}
          >
            Стоимость (в рублях)
          </div>
          )}
          {coexecutorData.isS && (
          <div
            className="common-table-row-cell"
            style={{
              width: '24%',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px solid #d9d9d9',
            }}
          >
            Ожидаемый результат
          </div>
          )}
        </div>

        {steps()
          .filter((el) => el.active)
          .map((el, index) => (
            <PlanRow
              index={index}
              step={el.step}
              coexecutorData={coexecutorData}
              formRef={formRef}
            />
          ))}
        <div
          className="common-table-row"
          style={{ borderBottom: '2px solid #d9d9d9' }}
        >
          <div
            className="common-table-row-cell"
            style={{
              fontWeight: 'bold',
              width: '84%',
              paddingRight: 15,
              borderRight: '1px solid #d9d9d9',
              textAlign: 'right',
            }}
          >
            Итого
          </div>
          <Form.Item
            initialValue={coexecutorData.coexecutorsPersonId}
            style={{ width: '20%' }}
          >
            <InputNumber
              formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              disabled
              value={coexecutorData.coexecutorsPersonId.stepTotal}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>
      </div>
    </>
  );
};

Plan.propTypes = {
  coexecutorData: PropTypes.shape().isRequired,
  formRef: PropTypes.shape().isRequired,
};

export default Plan;
